import { getDomain } from 'www/utils/get-domain';
class CommonSVPLoadModule {

    loadSVPLibrary(targetVer = '1.18.0') {
        return new Promise((resolve, reject) => {
            if (document.getElementById('fast-video')) return resolve();
            let bundleJS = document.createElement('script');
            document.getElementsByTagName("body")[0].appendChild(bundleJS);
            bundleJS.onload = function () {
                resolve();
            };
            // load video player version based on input/specific
            let loadVersion = '';
            bundleJS.src = `//img.${getDomain()}medscapestatic.com/medscape-promo/streaming-video-player/js/${targetVer}/streaming-video-player.bundle.js`;
        });
    }
}

export { CommonSVPLoadModule }
